import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

export function PrivateRoutes({ children }) {
  const authReducer = useSelector((state) => state.authReducer);
  return authReducer.isLogin === 'ACTIVE' ? (
    <Outlet />
  ) : (
    <Navigate to="{/user/login}" />
  );
}
